import { createSharedComposable, useMediaQuery } from "@vueuse/core";
import { computed } from "vue";

/** Matches Tailwind's default `md` and `lg` screens, so `max-md:` classes and these flags agree. */
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1024;

export const useAppBreakpoints = createSharedComposable(() => {
  const isAtLeastMd = useMediaQuery(`(min-width: ${BREAKPOINT_MD}px)`);
  const isAtLeastLg = useMediaQuery(`(min-width: ${BREAKPOINT_LG}px)`);

  const isPhone = computed(() => !isAtLeastMd.value);
  const isTablet = computed(() => isAtLeastMd.value && !isAtLeastLg.value);
  const isDesktop = computed(() => isAtLeastLg.value);

  return {
    isAtLeastMd,
    isAtLeastLg,
    isPhone,
    isTablet,
    isDesktop,
  };
});
